import axios from 'axios'
import store from '@/store'

export default {
  getProjectBusinessDeveloper (projectId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/projects/${projectId}/business-developer`, {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then((res) => {
        resolve(res)
      }, error => {
        reject(error)
      })
    })
  },
  getBusinessDevelopers () {
    return new Promise((resolve, reject) => {
      axios.get(`/api/get-business-developers`, {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then((res) => {
        store.dispatch('businessDevelopers/setBusinessDevelopers', res.data)
        resolve(res)
      }, error => {
        reject(error)
      })
    })
  }
}
